<div class="main-container">
    <button
        class="channel-select-button"
        (click)="onShowDropDownButtonClick()"
        [ngClass]="showDropDown ? 'active-channel-select-button' : 'inactive-channel-select-button'">
        <ng-container *ngIf="(currentChannel$ | async)?.logo">
            <img class="channel-logo" src="{{ (currentChannel$ | async).logo }}" alt="logo" />
        </ng-container>
        {{ (currentChannel$ | async)?.name ? (currentChannel$ | async).name : 'Chaîne' }}
        <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <div class="dropdown" [ngClass]="showDropDown ? 'visible-dropdown' : 'invisible-dropdown'">
        <div class="inputs-container">
            <div class="main-container">
                <button class="channel-group-select-button" (click)="onShowChannelGroupSelectDownButtonClick()">
                    {{ channelGroupButtonTitle }}
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <div
                    class="channel-group-select-dropdown"
                    [ngClass]="showChannelGroupSelectDropDown ? 'visible-dropdown' : 'invisible-dropdown'">
                    <div
                        class="channel-group-select-option"
                        *ngFor="let channelGroup of channelGroups"
                        (click)="onGroupSelectOptionClick(channelGroup)">
                        {{ channelGroup.name }}
                    </div>
                </div>
            </div>
            <div class="tv-round-input-extensible-no-label width-250px upper-lower-padding-10px">
                <mat-form-field>
                    <mat-label>Chaîne</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput #channelInput [formControl]="channelSearchControl" />
                    <button
                        matSuffix
                        aria-label="Clear"
                        class="tv-clear-input-icon-button"
                        [ngClass]="showClearButton ? 'tv-visible-clear-btn' : 'tv-invisible-clear-btn'"
                        (click)="clearChannelSearchInput()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="channel-list-container-wrapper">
                <div class="channel-list-container tv-custom-scroll-bar">
                    <ng-container *ngFor="let channel of channels$ | async | channelFilter : filter">
                        <div class="channel-item-container">
                            <button class="channel-button" (click)="onToggleFavoriteChannelClick(channel)">
                                <mat-icon [ngClass]="channel.isFavorite ? 'yellow' : 'grey'">star</mat-icon>
                            </button>
                            <div class="channel-title-image-container" (click)="onChooseChannelClick(channel)">
                                <img class="channel-logo" src="{{ channel.logo }}" />
                                <p class="channel-title">{{ channel.name }}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
